import React from 'react';
import { Box, Typography, Paper, Grid } from '@mui/material';
import {
  CheckCircle as CheckCircleIcon,
  Error as ErrorIcon,
  Email as EmailIcon,
  TrendingUp as RateIcon,
} from '@mui/icons-material';
import type { EmailStats } from '../../api/admin';

export function EmailStatsCards({ stats }: { stats: EmailStats }) {
  return (
    <Grid container spacing={2} sx={{ mb: 3 }}>
      <Grid size={{ xs: 12, sm: 6, md: 3 }}>
        <Paper sx={{ p: 2 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
            <EmailIcon color="primary" />
            <Typography variant="body2" color="text.secondary">
              Total Sent
            </Typography>
          </Box>
          <Typography variant="h5">
            {stats.totalSent.toLocaleString()}
          </Typography>
        </Paper>
      </Grid>
      <Grid size={{ xs: 12, sm: 6, md: 3 }}>
        <Paper sx={{ p: 2 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
            <CheckCircleIcon color="success" />
            <Typography variant="body2" color="text.secondary">
              Delivered
            </Typography>
          </Box>
          <Typography variant="h5" color="success.main">
            {stats.delivered.toLocaleString()}
          </Typography>
        </Paper>
      </Grid>
      <Grid size={{ xs: 12, sm: 6, md: 3 }}>
        <Paper sx={{ p: 2 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
            <RateIcon color="info" />
            <Typography variant="body2" color="text.secondary">
              Delivery Rate
            </Typography>
          </Box>
          <Typography variant="h5" color="info.main">
            {(stats.deliveryRate * 100).toFixed(1)}%
          </Typography>
        </Paper>
      </Grid>
      <Grid size={{ xs: 12, sm: 6, md: 3 }}>
        <Paper sx={{ p: 2 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
            <ErrorIcon color="error" />
            <Typography variant="body2" color="text.secondary">
              Failed / Bounced
            </Typography>
          </Box>
          <Typography variant="h5">
            {stats.failed} / {stats.bounced}
          </Typography>
          <Typography variant="caption" color="text.secondary">
            Complaints: {stats.complained}
          </Typography>
        </Paper>
      </Grid>
    </Grid>
  );
}
